import { useV2ListPhasesForAccountQuery } from "@generated";

export interface PhaseItem {
  id: string;
  name: string;
  position: number;
}

const useListPhases = () => {
  const { data, isLoading, error } = useV2ListPhasesForAccountQuery({
    filter: { active: true } as any,
    page: { number: 1, size: 1000 },
  });

  const phases: PhaseItem[] = (data?.data ?? [])
    .filter((p) => p.id)
    .map((p) => ({
      id: String(p.id),
      name: (p.attributes as any)?.name ?? "",
      position: (p.attributes as any)?.position ?? 0,
    }))
    .sort((a, b) => a.position - b.position);

  return { phases, phasesLoading: isLoading, error };
};

export default useListPhases;
